const LINKED_SLOTTED_ELEMENTS_EVENT_TYPE = "crnt-linked-slotted-elements";
class LinkedSlottedElementsEvent extends Event {
  constructor() {
    super(LINKED_SLOTTED_ELEMENTS_EVENT_TYPE);
  }
}

export { LINKED_SLOTTED_ELEMENTS_EVENT_TYPE, LinkedSlottedElementsEvent };
